import React, { useEffect, useState } from "react";
import { useFontAwesomeIconPack } from "../../hooks/useFontAwesomeIconPack";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { IconLookup } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { Input } from "../ui/input";
import Button from "./button";
import { cn } from "../../lib/utils";
import { Skeleton } from "../ui/skeleton";

interface IconSelectPopupProps {
    icon?: IconLookup;
    icons: IconLookup[];
    label?: string;
    onChange: (i: IconLookup) => void;
}
export default function IconSelectPopup({ icon, icons, label, onChange }: IconSelectPopupProps) {
    const [open, setOpen] = useState(false);

    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger className="flex w-fit items-center gap-2">
                {label}
                <Button size={"box"} className="text-slate-600">
                    {icon ? <FontAwesomeIcon icon={icon} /> : "X"}
                </Button>
            </PopoverTrigger>
            <PopoverContent align="end">
                <IconSelectField
                    icons={icons}
                    icon={icon}
                    onChange={(i) => {
                        onChange(i);
                        setOpen(false);
                    }}
                    className="grid-cols-7"
                />
            </PopoverContent>
        </Popover>
    );
}

interface IconSelectFieldProps {
    icon?: IconLookup;
    icons: IconLookup[];
    label?: string;
    onChange: (i: IconLookup) => void;
    className?: string;
}

export function IconSelectField({ icon, icons, onChange, className = "grid-cols-8" }: IconSelectFieldProps) {
    const [filteredIcons, setFilteredIcons] = useState<IconLookup[]>([]);
    useEffect(() => {
        setFilteredIcons(icons);
    }, [icons]);
    return (
        <div>
            <Input className="mb-4" placeholder="search..." onChange={(e) => setFilteredIcons(icons.filter((icon) => icon.iconName.includes(e.target.value.toLowerCase())))} />
            <div className={cn("scrollbar grid max-h-56 gap-2 overflow-y-scroll p-2", className)}>
                {filteredIcons.map((i) => (
                    <button
                        className={`flex items-center justify-center p-1 text-slate-500 ${i.iconName === icon?.iconName && i.prefix === icon?.prefix && "rounded-lg text-slate-900 ring-2 ring-slate-900 dark:text-slate-300 dark:ring-slate-300"}`}
                        onClick={() => {
                            onChange(i);
                        }}>
                        <FontAwesomeIcon icon={i} size="lg" />
                    </button>
                ))}
            </div>
        </div>
    );
}
